<template>
  <div class="full">
    <!-- <button @click="sendCanvas">Send</button>
    <button @click="$emit('show', 'mainscreen')">Close</button> -->
    <div class="draw-div" ref="concon">
      <canvas class="cancan" ref="cancan"></canvas>
    </div>
    <div class="anchor-top-left">

      <img v-if="currentItem" @click="removeCurrentItem"  class="icon-margin button icon" src="./img/trash.svg" alt="">
      <img @click="newText"  class="icon-margin button icon" src="./img/text.svg" alt="">

      <img v-if="fabricCanvas.isDrawingMode" @click="toggleDrawMode"  class="icon-margin button icon" src="./img/cursor.svg" alt="">
      <img v-if="!fabricCanvas.isDrawingMode" @click="toggleDrawMode"  class="icon-margin button icon" src="./img/pencil.svg" alt="">

      <span class="suggestion-title" v-if="autodrawSuggestions.length > 0">
        Suggested Drawings:
      </span>
      <div class="suggestions" v-if="autodrawSuggestions.length > 0">
        <span :key="idx" v-for="(sug, idx) in autodrawSuggestions">
          <img v-if="fabricCanvas.isDrawingMode" @click="insertAutoDraw({ url: sug.url })" onerror="this.style.display='none'" class="icon-margin autodraw-icon button icon" :src="sug.url" :alt="sug.name">
          <img v-if="fabricCanvas.isDrawingMode" @click="insertAutoDraw({ url: sug.url_variant_1 })" onerror="this.style.display='none'" class="icon-margin autodraw-icon button icon" :src="sug.url_variant_1" :alt="sug.name">
          <img v-if="fabricCanvas.isDrawingMode" @click="insertAutoDraw({ url: sug.url_variant_2 })" onerror="this.style.display='none'" class="icon-margin autodraw-icon button icon" :src="sug.url_variant_2" :alt="sug.name">
        </span>
      </div>

      <!--
      <div class="button" @click="useLineColor('#ff0000', 1)" :style="getBG('#ff0000')">1</div>
      <div class="button" @click="useLineColor('#00ff00', 1)" :style="getBG('#00ff00')">1</div>
      <div class="button" @click="useLineColor('#0000ff', 1)" :style="getBG('#0000ff')">1</div>
      <div class="button" @click="useLineColor('#0f0f0f', 1)" :style="getBG('#0f0f0f')">1</div>

      <div class="button" @click="useLineColor('rgba(255, 255, 0, 0.3)', 20)" :style="getBG('rgba(255, 255, 0, 0.3)')">20</div>
      <div class="button" @click="useLineColor('rgba(0, 255, 0, 0.3)', 20)" :style="getBG('rgba(0, 255, 0, 0.3)')">20</div>
      <div class="button" @click="useLineColor('rgba(0, 255, 255, 0.3)', 20)" :style="getBG('rgba(0, 255, 255, 0.3)')">20</div>
      -->

    </div>
    <div class="bottom-left">
      <img @click="$emit('show', 'mainscreen')" class="icon-margin button icon" src="./img/close.svg" alt="">
    </div>
    <div class="bottom-right">
      <img @click="sendCanvas" class="icon-margin button icon" src="./img/plane.svg" alt="">
    </div>

    <div class="top-right">
      <Slider v-if="isAtMobile" class="slider" v-model="lineColor" />
      <Chrome v-if="!isAtMobile" class="slider" v-model="lineColor" />
      <input class="thickness" type="range" v-model="lineWidth">
    </div>

  </div>
</template>

<script>
import * as LoadImg from 'blueimp-load-image'
import NProgress from 'nprogress'
import * as fabricWrap from 'fabric-webpack'
// import vueSlider from 'vue-slider-component'
import autodraw from './autodraw.js'
import axios from 'axios'
let fabric = fabricWrap.fabric

console.log(fabric)

// const SimpleDrawingBoard = require('simple-drawing-board')

// https://yoteachapp.com/yo/yoteach

/* eslint-disable */
function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {
  if (arguments.length === 2) {
      x = y = 0;
      w = ctx.canvas.width;
      h = ctx.canvas.height;
  }

  // default offset is center
  offsetX = typeof offsetX === "number" ? offsetX : 0.5;
  offsetY = typeof offsetY === "number" ? offsetY : 0.5;

  // keep bounds [0.0, 1.0]
  if (offsetX < 0) offsetX = 0;
  if (offsetY < 0) offsetY = 0;
  if (offsetX > 1) offsetX = 1;
  if (offsetY > 1) offsetY = 1;

  var iw = img.width,
      ih = img.height,
      r = Math.min(w / iw, h / ih),
      nw = iw * r,   // new prop. width
      nh = ih * r,   // new prop. height
      cx, cy, cw, ch, ar = 1;

  // decide which gap to fill
  if (nw < w) ar = w / nw;
  if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
  nw *= ar;
  nh *= ar;

  // calc source rectangle
  cw = iw / (nw / w);
  ch = ih / (nh / h);

  cx = (iw - cw) * offsetX;
  cy = (ih - ch) * offsetY;

  // make sure source rectangle is valid
  if (cx < 0) cx = 0;
  if (cy < 0) cy = 0;
  if (cw > iw) cw = iw;
  if (ch > ih) ch = ih;

  // fill image in dest. rectangle
  ctx.drawImage(img, cx, cy, cw, ch,  x, y, w, h);
}

function drawImageScaled (ctx, img) {
  var canvas = ctx.canvas
  var hRatio = canvas.width / img.width
  var vRatio =  canvas.height / img.height
  var ratio  = Math.min(hRatio, vRatio)
  var centerShift_x = (canvas.width - img.width*ratio) / 2
  var centerShift_y = (canvas.height - img.height*ratio) / 2
  ctx.clearRect(0,0,canvas.width, canvas.height)
  ctx.drawImage(img, 0,0, img.width, img.height, centerShift_x,centerShift_y,img.width*ratio, img.height*ratio)
}
/* eslint-enable */
var { Chrome, Slider } = require('vue-color')

export default {
  components: {
    Chrome,
    // vueSlider,
    Slider
  },
  props: {
  },
  data () {
    return {
      isAtMobile: window.innerWidth < 500,
      lineWidth: 1,
      lineColor: {
        hex: '#000000'
      },
      autodrawSuggestions: [],
      autodrawDown: false,
      autodraws: [[]],
      currentItem: false,
      fabricCanvas: false,
      size: 2 * (window.devicePixelRatio || 1.0),
      // sdb: false,
      defaultImage: `data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7`
    }
  },
  watch: {
    lineColorHex () {
      this.fabricCanvas.freeDrawingBrush.color = this.lineColorHex
    },
    lineWidth () {
      this.fabricCanvas.freeDrawingBrush.width = this.lineWidth
    }
  },
  computed: {
    lineColorHex () {
      return this.lineColor.hex8
    }
  },
  mounted () {
    if (!this.fabricCanvas) {
      // this.resizeCanvas()
      this.$refs['concon'].addEventListener('touchstart', (e) => {
        e.preventDefault()
      }, false)
      this.$refs['concon'].addEventListener('touchmove', (e) => {
        e.preventDefault()
      }, false)
      let rect = this.$parent.$el.getBoundingClientRect()
      let win = {
        innerWidth: rect.width,
        innerHeight: rect.height
      }
      this.$refs['cancan'].width = win.innerHeight * (win.innerWidth / win.innerHeight)
      this.$refs['cancan'].height = win.innerHeight

      this.fabricCanvas = new fabric.Canvas(this.$refs['cancan'], {
        enableRetinaScaling: true,
        isDrawingMode: true,
        backgroundColor: 'rgba(255,255,255,1.0)'
      })

      this.cleanAutoDrawStrokes()
      this.fabricCanvas.on('mouse:down', (e) => {
        if (this.fabricCanvas.isDrawingMode) {
          // this.autodraws.push([])
          this.autodrawDown = true
          console.log('mouse down', e)
        }
      })
      this.fabricCanvas.on('mouse:move', (e) => {
        if (this.fabricCanvas.isDrawingMode && this.autodrawDown) {
          this.autodraws[this.autodraws.length - 1].push({
            x: e.e.clientX + 0,
            y: e.e.clientY + 0
          })
          console.log('mouse move', e)
        }
      })
      this.fabricCanvas.on('mouse:up', (e) => {
        if (this.fabricCanvas.isDrawingMode) {
          console.log('mouse up', e)
          this.autodrawDown = false
          console.log(this.autodraws)
          let frame = {
            width: this.fabricCanvas.width,
            height: this.fabricCanvas.height
          }
          autodraw(this.autodraws, frame).then((v) => {
            this.autodrawSuggestions = v.sort((a, b) => {
              if (a.confidence > b.confidence) {
                return -1
              }
              if (a.confidence < b.confidence) {
                return 1
              }
              return 0
            })
            console.log(this.autodrawSuggestions)
          }, (e) => {
            console.log(e)
          })
        }
      })

      setInterval(() => {
        this.currentItem = this.fabricCanvas.getActiveObject()
      }, 100)
    }
  },
  methods: {
    getSVGDataURL (oldURL) {
      let host = `storage.googleapis.com`
      let link = `${oldURL.replace('https://storage.googleapis.com/', '')}`
      let url = `https://yoteach-cloud.herokuapp.com/yo/palms-proxy?hoster=${encodeURIComponent(host)}&linker=${encodeURIComponent(link)}`
      console.log(url, oldURL, link)
      return `${url}`
    },
    cleanAutoDrawStrokes () {
      this.autodraws = [[]]
    },
    cleanAutoSuggestions () {
      this.autodrawSuggestions = []
    },
    insertAutoDraw ({ url }) {
      this.cleanCanvas()
      this.cleanAutoDrawStrokes()
      setTimeout(() => {
        let needURL = this.getSVGDataURL(url)
        axios.get(needURL).then((resp) => {
          console.log(resp.data)
          let dataURI = `data:image/svg+xml;utf8,${encodeURIComponent(resp.data)}`
          fabric.Image.fromURL(dataURI, (img) => {
            img.originX = 'center'
            img.originY = 'center'
            img.top = this.fabricCanvas.getHeight() / 2
            img.left = this.fabricCanvas.getWidth() / 2
            // img.scaleX = this.fabricCanvas.getWidth()
            // img.scaleY = this.fabricCanvas.getHeight()// / canvas2d.height

            this.fabricCanvas.add(img)
          })
        })
      }, 0)
    },
    toJSON () {
      this.currentItem = this.fabricCanvas.getActiveObject()
      console.log(this.currentItem)
    },
    getBG (color) {
      return {
        backgroundColor: color || '#000000'
      }
    },
    useLineColor (color, lineWidth) {
      this.lineColor = color
      this.lineWidth = lineWidth
    },
    newText () {
      let newText = new fabric.Textbox(window.prompt('add text: '))
      if (this.fabricCanvas) {
        newText.originX = 'center'
        newText.originY = 'center'

        newText.top = this.fabricCanvas.getHeight() / 2
        newText.left = this.fabricCanvas.getWidth() / 2
        this.fabricCanvas.isDrawingMode = false
        this.fabricCanvas.add(newText)
      }
    },
    removeCurrentItem () {
      this.fabricCanvas.getActiveObject().remove()
    },
    resizeCanvas () {
      // let dpi = window.devicePixelRatio || 1.0
      // var vmin = Math.min(window.innerWidth,)
      if (this.fabricCanvas) {
        let rect = this.$parent.$el.getBoundingClientRect()
        let win = {
          innerWidth: rect.width,
          innerHeight: rect.height
        }
        let width = win.innerHeight * (win.innerWidth / win.innerHeight)
        let height = win.innerHeight
        this.fabricCanvas.setDimensions({
          width,
          height
        })
      }
    },
    reset ({ imageURL }) {
      let canvas = this.$refs['cancan']
      this.resizeCanvas()
      this.cleanCanvas()
      this.cleanAutoDrawStrokes()
      this.cleanAutoSuggestions()
      this.drawBG({ canvas, imageURL: imageURL || this.defaultImage })
    },
    toggleDrawMode () {
      if (this.fabricCanvas) {
        this.fabricCanvas.isDrawingMode = !this.fabricCanvas.isDrawingMode
        this.fabricCanvas.getObjects().forEach((i) => {
          i.hasControls = !this.fabricCanvas.isDrawingMode
          i.hasBorders = !this.fabricCanvas.isDrawingMode
        })
        this.fabricCanvas.renderAll()
      }
    },
    drawBG ({ canvas, imageURL }) {
      return new Promise((resolve, reject) => {
        NProgress.start()
        let rect = this.$parent.$el.getBoundingClientRect()
        let win = {
          innerWidth: rect.width,
          innerHeight: rect.height
        }
        // NProgress.start()
        // setTimeout(() => {
        //   NProgress.done()
        // }, 1000 * 20)
        LoadImg(imageURL, (correctedCanvas) => {
          // let rect = this.$refs['cancan'].getBoundingClientRect()
          // let dpx = 1.0 // window.devicePixelRatio || 1.0
          let canvas2d = document.createElement('canvas')

          canvas2d.width = 4096 * (win.innerWidth / win.innerHeight)
          canvas2d.height = 4096// * 1 / (window.innerWidth / window.innerHeight)

          // canvas2d.width = 1024
          // canvas2d.height = 1024 * 1 / (window.innerWidth / window.innerHeight)

          // * (correctedCanvas.width / correctedCanvas.height)
          // // drawImageProp(canvas2d.getContext('2d'), correctedCanvas)

          let canvas2dCtx = canvas2d.getContext('2d')
          canvas2dCtx.fillStyle = '#ffffff'
          canvas2dCtx.fillRect(0, 0, canvas2dCtx.canvas.width, canvas2dCtx.canvas.height)
          drawImageScaled(canvas2dCtx, correctedCanvas)

          let dataURI = canvas2d.toDataURL('image/png', 1.0)

          if (this.fabricCanvas) {
            this.fabricCanvas.clear()
          }

          fabric.Object.prototype.transparentCorners = false
          fabric.Image.fromURL(dataURI, (img) => {
            img.originX = 'center'
            img.originY = 'center'
            img.top = this.fabricCanvas.getHeight() / 2
            img.left = this.fabricCanvas.getWidth() / 2
            img.scaleX = this.fabricCanvas.getWidth() / canvas2d.width
            img.scaleY = this.fabricCanvas.getHeight() / canvas2d.height

            if (imageURL !== this.defaultImage) {
              this.fabricCanvas.add(img)
            }
            // this.fabricCanvas.backgroundImage = img
            resolve()
            NProgress.done()
          })

          // this.fabricCanvas = new fabric.Canvas(context.canvas, {
          //   isDrawingMode: true
          // })
          // fabric.Object.prototype.transparentCorners = false

          // var fabricCanvasBG = new fabric.Canvas(correctedCanvas)
          // this.fabricCanvas.add(fabricCanvasBG)

          // this.sdb = new SimpleDrawingBoard(context.canvas, {
          //   lineColor: '#FF0000',
          //   lineSize: this.size,
          //   boardColor: 'white',
          //   historyDepth: 10
          // })
          // this.sdb.setImg(canvas2d, true)
        }, {
          orientation: true,
          canvas: true, // ,
          crossOrigin: window.location.origin || '*'
        })
      })
    },
    cleanCanvas () {
      if (this.fabricCanvas) {
        this.fabricCanvas.clear()
      }
    },
    // runCanvas ({ context }) {
    //   // begin custom shape
    //   context.beginPath()
    //   context.moveTo(170, 80)
    //   context.bezierCurveTo(130, 100, 130, 150, 230, 150)
    //   context.bezierCurveTo(250, 180, 320, 180, 340, 150)
    //   context.bezierCurveTo(420, 150, 420, 120, 390, 100)
    //   context.bezierCurveTo(430, 40, 370, 30, 340, 50)
    //   context.bezierCurveTo(320, 5, 250, 20, 250, 50)
    //   context.bezierCurveTo(200, 5, 150, 20, 170, 80)

    //   // complete custom shape
    //   context.closePath()
    //   context.lineWidth = 5
    //   context.fillStyle = '#8ED6FF'
    //   context.fill()
    //   context.strokeStyle = 'blue'
    //   context.stroke()
    // },
    sendCanvas () {
      // let canvas = this.$refs['cancan']
      // let context = canvas.getContext('2d')
      // this.runCanvas({ context })
      this.fabricCanvas.getObjects().forEach((i) => {
        i.___hasControls = i.hasControls
        i.___hasBorders = i.hasBorders

        i.hasControls = false
        i.hasBorders = false
      })

      this.fabricCanvas.isDrawingMode = true
      this.fabricCanvas.renderAll()

      setTimeout(() => {
        var dataURL = this.fabricCanvas.toDataURL({
          format: 'jpeg',
          quality: 0.7,
          enableRetinaScaling: true
        })
        console.log(dataURL)
        // var data = dataURItoBlob(dataURL)
        this.$emit('send', { imageURL: dataURL })
        this.$emit('sending', true)
        this.$emit('show', 'mainscreen')

        this.fabricCanvas.getObjects().forEach((i) => {
          i.hasControls = i.___hasControls
          i.hasBorders = i.___hasBorders
        })
      }, 100)
    }
  }
}
</script>
<style scoped>
.icon-margin{
  margin: 10px 10px 10px 0px;
}
.cancan{
  touch-action: manipulation;
  width: 100%;
}
.draw-div{
  touch-action: manipulation;
  background-color: rgb(230, 255, 233);
  width: 100%;
  height: 100%;
  /* height: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  justify-self: stretch;
}
.anchor-top-left{
  position: absolute;
  top: 10px;
  left: 20px;
}
@media screen and (min-width: 767px) {
  .anchor-top-left{
    max-width: calc(100% - 270px);
  }
}

.full{
  width: 100%;
  height: 100%;
}

.bottom-left{
  position: absolute;
  bottom: 10px;
  left: 20px;
}

.bottom-right{
  position: absolute;
  bottom: 10px;
  right: 20px;
}

.top-right{
  position: absolute;
  top: 20px;
  right: 20px;

}

.slider{
  width: 200px;
  /* transform: rotate(90deg) translate3d(102px, -58px, 0); */
}
input[type=range] {
  -webkit-appearance: none;
  width: 100%;
  margin: 1.85px 0;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 13.3px;
  cursor: pointer;
  box-shadow: 1.4px 1.4px 1.7px #ffb2df, 0px 0px 1.4px #ffccea;
  background: #ffffff;
  border-radius: 25px;
  border: 2.3px solid #dbd59b;
}
input[type=range]::-webkit-slider-thumb {
  box-shadow: 4.1px 4.1px 7.2px #27aaff, 0px 0px 4.1px #41b4ff;
  border: 5px solid #ffffff;
  height: 17px;
  width: 18px;
  border-radius: 38px;
  background: #ffffff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -4.15px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  background: #ffffff;
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 13.3px;
  cursor: pointer;
  box-shadow: 1.4px 1.4px 1.7px #ffb2df, 0px 0px 1.4px #ffccea;
  background: #ffffff;
  border-radius: 25px;
  border: 2.3px solid #dbd59b;
}
input[type=range]::-moz-range-thumb {
  box-shadow: 4.1px 4.1px 7.2px #27aaff, 0px 0px 4.1px #41b4ff;
  border: 5px solid #ffffff;
  height: 17px;
  width: 18px;
  border-radius: 38px;
  background: #ffffff;
  cursor: pointer;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 13.3px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: #e0e0e0;
  border: 2.3px solid #dbd59b;
  border-radius: 50px;
  box-shadow: 1.4px 1.4px 1.7px #ffb2df, 0px 0px 1.4px #ffccea;
}
input[type=range]::-ms-fill-upper {
  background: #ffffff;
  border: 2.3px solid #dbd59b;
  border-radius: 50px;
  box-shadow: 1.4px 1.4px 1.7px #ffb2df, 0px 0px 1.4px #ffccea;
}
input[type=range]::-ms-thumb {
  box-shadow: 4.1px 4.1px 7.2px #27aaff, 0px 0px 4.1px #41b4ff;
  border: 5px solid #ffffff;
  height: 17px;
  width: 18px;
  border-radius: 38px;
  background: #ffffff;
  cursor: pointer;
  height: 13.3px;
}
input[type=range]:focus::-ms-fill-lower {
  background: #ffffff;
}
input[type=range]:focus::-ms-fill-upper {
  background: #ffffff;
}

input.thickness[type=range]{
  margin-top: 18px;
  width: 200px;
}

.suggestions{
  overflow-x: scroll;
  height: 90px;
  border: #d0d0d0 solid 1px;
  padding: 18px;
}

.autodraw-icon{
  height: 60px;
  margin-top: 0px;
}

.suggestion-title{
  transform: translateY(-24px);
  display: inline-block;
  font-weight: bold;
}
</style>
